import React from 'react'
import { Text } from 'react-native'

export const Link = (props: any) => <Text {...props} accessibilityRole="link" target={'_blank'} rel={'noopener noreferrer'} style={props.style} />
